/*    
<summary>
  This functional component "AdvanceSearchPopupHOC" provides props to the child component.
  1. State "showAdvanceSearchPopup" that manages the show/hide of pop up
  2. Function "advanceSearchPopupToggleHandler" to toggle the show/hide popup state "showAdvanceSearchPopup"
  Developer:Aashish Singh, Created Date:30-July-2025
</summary>
<returns>Returns JSX</returns>
*/

import React, {useState } from 'react';

const AdvanceSearchPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showAdvanceSearchPopup,setShowAdvanceSearchPopup] = useState<boolean>(false);

    const advanceSearchToggleHandler = () => {
        setShowAdvanceSearchPopup(!showAdvanceSearchPopup);
    }
    
    return <Component showAdvanceSearchPopup={showAdvanceSearchPopup} advanceSearchPopupToggleHandler={advanceSearchToggleHandler} {...props}/>;
};

export default AdvanceSearchPopupHOC;   